import React from 'react';
import { FiInfo } from 'react-icons/fi';

/**
 * InfoNote Component - Displays informational notes with yellow/orange background and info icon
 * @param {Object} props
 * @param {string|React.ReactNode} props.children - The content to display in the note
 * @param {string} [props.className] - Additional CSS classes
 * @param {Object} [props.style] - Additional inline styles
 */
const InfoNote = ({ children, className = '', style = {} }) => {
  return (
    <div
      className={`d-flex align-items-start ${className}`}
      style={{
        backgroundColor: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '4px',
        padding: '12px 16px',
        marginTop: '15px',
        marginBottom: '15px',
        ...style
      }}
    >
      <FiInfo
        style={{
          color: '#856404',
          fontSize: '18px',
          marginRight: '12px',
          marginTop: '2px',
          flexShrink: 0
        }}
      />
      <div
        style={{
          color: '#856404',
          fontSize: '14px',
          lineHeight: '1.5',
          flex: 1
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default InfoNote;
